import type { AppUser } from "~~/types/user";

export const useAuthUser = () => {

    const user = useState<AppUser | null>("auth-user", () => null);
    const loading = useState<boolean>("auth-loading", () => true);

    const updateUserAvatar = (avatar: string | null) => {
        if (user.value) {
            user.value.avatar = avatar;
        }
    }
    const getUser = async () => {
        console.log("Auth user called...")
        try {
            const requestFetch = useRequestFetch();
            const response = await requestFetch<any>("/api/auth/check-auth");
            user.value = response.user ?? null;
        } catch {
            user.value = null;
        } finally {
            loading.value = false;
        }
    };

    return { user, loading, getUser, updateUserAvatar };
};